import type { ServiceAreaData } from './service-area-data';
import brokenArrow from './towns/broken-arrow';
import catoosa from './towns/catoosa';
import claremore from './towns/claremore';
import inola from './towns/inola';
import owasso from './towns/owasso';
import rogersCounty from './towns/rogers-county';
import tulsa from './towns/tulsa';
import verdigris from './towns/verdigris';

export type { ServiceAreaData } from './service-area-data';

export const SERVICE_AREA_DATA_MAP: Record<string, ServiceAreaData> = {
  'broken-arrow': brokenArrow,
  'catoosa': catoosa,
  'claremore': claremore,
  'inola': inola,
  'owasso': owasso,
  'rogers-county': rogersCounty,
  'tulsa': tulsa,
  'verdigris': verdigris,
};

export const SERVICE_AREA_SLUGS = Object.keys(SERVICE_AREA_DATA_MAP);
